import React, { Dispatch, SetStateAction } from 'react';
import { Flex, Box, Radio, RadioGroup } from '@cad-arc';
import { FormatType } from './maritime-formats-buttons-section';

export function MaritimeFormatsRadioButtonsSection({
    formattedValue,
    activeFormat,
    setActiveFormat,
}: {
    formattedValue?: string;
    activeFormat: FormatType;
    setActiveFormat: Dispatch<SetStateAction<FormatType>>;
}) {
    return (
        <Flex
            data-testid="maritime-radiobuttons-section"
            alignItems="center"
            justifyItems="center"
            justifyContent="space-between"
            gap={2}
            m="8px auto"
        >
            {formattedValue && <Box>{formattedValue}</Box>}
            <RadioGroup
                defaultValue="DD"
                size="md"
                onChange={(value) => setActiveFormat((value as unknown) as FormatType)}
                value={activeFormat}
            >
                <Radio value="DD">DD</Radio>
                <Radio value="DMS">DMS</Radio>
                <Radio value="DDM">DDM</Radio>
            </RadioGroup>
        </Flex>
    );
}
